"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = ChartDescription;
var _react = _interopRequireDefault(require("react"));
var _ChartDescription = require("./ChartDescription.styled");
function ChartDescription(_ref) {
  let {
    description,
    centered = false,
    size = "medium",
    error = false
  } = _ref;
  if (!description) {
    return null;
  }
  return /*#__PURE__*/_react.default.createElement(_ChartDescription.ChartDescriptionWrap, {
    error: error,
    centered: centered,
    size: size,
    dangerouslySetInnerHTML: {
      __html: description
    }
  });
}